<template>
    <gofix-card fullContent class="mb-0 pt-20">
        <b-col md="12">
            <b-row>
                <b-col md="3">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Month"
                                :clearable="false"
                                :filterable="false"  
                                fullContent
                                :searchable="false"
                                :options="months"
                                vLabel="text"
                                :reduce="option => option.value"
                                v-model="month">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Year"
                                :clearable="false"
                                :filterable="false" 
                                :searchable="false"
                                :options="years"
                                v-model="year">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Supplier Contract"
                                vLabel="contract_name"
                                @search="searchSupplierContract"
                                :filterable="false"
                                v-model="supplier_contract"
                                :options="supplier_contracts">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Property Type" 
                                :filterable="false"
                                :clearable="false"
                                :options="property_types" 
                                v-model="property_type"
                                required 
                                show-icon-required>
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="12" class="text-center pt-15">
                            <!-- <gofix-button class="mr-10" label="Save" @click="saveReport()" :disabled="activeSaveBtn == false"></gofix-button> -->
                            <gofix-button label="Export PDF" @click="exportReport()" :disabled="activeExportBtn == false"></gofix-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <hr/>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @row-click="openModalEdit"
            ref="gofixTable">
            <template slot="gofix_table:average_score" slot-scope="row">
                {{ `${row.item.average_score}%` }}
            </template>
            <!-- <template slot="gofix_table:adjust" slot-scope="row">
                <span class="fakeInput text-center" style="width: 100px; float: right;"> {{ `${row.item.adjust}%` }} </span>
            </template> -->
            <template slot="gofix_table:adjust" slot-scope="row">
                {{ `${row.item.adjust}%` }}
            </template>
            <template slot="gofix_table:deduction" slot-scope="row">
                {{ `${row.item.deduction}%` }}
            </template>
            <template slot="gofix_table:percent_payment_to_cv" slot-scope="row">
                {{ `${row.item.percent_payment_to_cv}%` }}
            </template>
            <template slot="gofix_table:payment_to_cv" slot-scope="row">
                {{ row.item.payment_to_cv | formatMoney }}
            </template>
            <template slot="gofix_table:less_rates_of_deduction" slot-scope="row">
                {{ row.item.less_rates_of_deduction | formatMoney }}
            </template>
        </gofix-table>
        <b-modal
                :no-close-on-backdrop="true"
                id="modal-Create"
                :title="modals.edit.title"
                hide-footer
                :centered="true"
                v-model="modals.edit.open">
            <div class="" v-bind:class="{'run-loading': modals.edit.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-input-number
                                label="Adjust (No)"
                                thousandsSeparatorSymbol=""
                                :includeThousandsSeparator="false"
                                v-model="modals.edit.data.adjust"
                                allowNegative
                            />
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="Submit" @click="saveDrafDataEntry" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </gofix-card>
</template>
<script>
import moment from 'moment';
export default {
    name: 'interim-report',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'table-interim-report',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: { },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'location_name',
                        label: 'Division',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'average_score',
                        label: 'Average Score',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    // {
                    //     key: 'adjust',
                    //     label: 'Adjust',
                    //     isActive: 1,
                    //     isFilter: false,
                    //     sorting: false,
                    //     thClass: 'text-right',
                    //     tdClass: 'text-right'
                    // },
                    {
                        key: 'deduction',
                        label: 'Deduction',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'percent_payment_to_cv',
                        label: 'Payment to CV (%)',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'less_rates_of_deduction',
                        label: 'Rates of Deduction',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'payment_to_cv',
                        label: 'Payment to CV ($)',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            supplier_contract: '',
            locations: [],
            location: '',
            property_types: ['Residential', 'Hawker Centre'],
            property_type: 'Residential',
            years: [],
            year: '',
            months: [],
            month: '',
            timer: null,
            activeExportBtn: false,
            activeSaveBtn: false,
            modals: {
                edit : {
                    open: false,
                    loading: false,
                    title: "Edit Adjust	",
                    data: {
                        adjust: 0,
                        index: 0
                    },
                },
                comfirmReload: {
                    open:false,
                    loading: false,
                    data: []
                }
            },
        }
    },
    watch: {
        ClientContractID: function(val) {
            this.getSupplierContract(null, true);
        },
        "supplier_contract": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "location": function(val) {
            if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        "property_type": function(val) {
           if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        "month": function(val) {
            if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        "year": function(val) {
            if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
    },
    created() {
        this.getInitData()
        this.getSupplierContract(null, true);
    },
    filters: {
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            
            if ( !this.supplier_contract ) {
                this.activeExportBtn = false
                const response = {
                    items: [],
                    total: 0
                }
                resolve(response);
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                return;
            }

            tableRequest.month = this.month
            tableRequest.year = this.year
            tableRequest.contract_id = this.supplier_contract.id
            tableRequest.property_type = this.property_type
            tableRequest.type = 'interim report'
            
            await this.$store.dispatch("PAConservancyController/getPAReport", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                resolve(response);

                if(this.tableConfig.total != 0){
                    this.activeExportBtn = true
                }else{
                    this.activeExportBtn = false
                }

                this.activeSaveBtn = false
            })
            .catch(err => { })
        },
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            
            for(var i=0;i<15;i++){
                this.years.push(iYear);
                iYear--;
            }
            this.month = moment().format('MM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonth = 0;
            var iMonths = [];
            while(iMonth<12){
                var dTime = mTime.clone();
                dTime.add(iMonth,'month');
                iMonths.push({'text' : dTime.format('MMMM'), 'value' : dTime.format('MM')});
                iMonth++;
            }
            this.months = iMonths;
        },
        async getSupplierContract(search = null, is_set_default = false) {
            this.loading = true
            let tableRequest = {
                filter: {
                    contract_name: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true
            }
            this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.supplier_contracts = response.data.data.contracts
                if(is_set_default) {
                    this.supplier_contract = null
                    if(response.data.data.contracts[0]){
                        this.supplier_contract = response.data.data.contracts[0]
                    }
                }
                this.loading = false
            })
            .catch(err => {
                this.loading = false
            })
        },
        searchSupplierContract(search, loading){
            loading(true);
            this.supplier_contracts = []
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getSupplierContract(search);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async dataPAReport() {
            if ( !this.supplier_contract ) {
                return false;
            }
            
            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                type: 'interim report'
            };

            await this.$store.dispatch("PAConservancyController/getPAReport", getParam)
            .then(response => {
                this.tableItems = response.items
            })
            .catch(err => { })
        },
        async exportReport() {

            let newData = this.tableItems.map(function(item) {
                return {
                    location_id: item.location_id,
                    adjust: item.adjust
                }
            });

            let checkPercent = false
            let totalPercent = 0

            newData.map(item => {
                item.adjust = this.$accounting.unformat(item.adjust)
                totalPercent = totalPercent + item.adjust
            })

            // if ( totalPercent > 100 ) {
            //     return this.$alertNotification("Total Adjust must be less than or equal to 100%", "danger")
            // }

            let getNewParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                type: 'interim report',
                is_download_pdf: true,
                location_adjusts: newData
            };

            await this.$store.dispatch("PAConservancyController/exportPAReport", getNewParam)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'consolidated-report-all-locations-' + this.month + '-' + this.year + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },
        openModalEdit(item,index){
            // this.modals.edit.title = item.location_name;
            // this.modals.edit.data.adjust = item.adjust || 0
            // this.modals.edit.data.index = index
            // this.modals.edit.open = true
        },
        saveDrafDataEntry(){
            let adjust = parseInt(this.modals.edit.data.adjust)

            if ( !adjust ) {
                adjust = 0;
            }
            if ( adjust > 100 ) {
                return this.$alertNotification("Total Adjust must be less than or equal to 100%", "danger")
            }

            let index = this.modals.edit.data.index
            this.tableItems[index].adjust = adjust
            this.tableItems[index].payment_to_cv = adjust + this.tableItems[index].average_score
            this.modals.edit.open = false
            this.activeSaveBtn = true
        },
        async saveReport() {

            let items = this.tableItems.map(function(item) {
                return {
                    property_id: item.location_id,
                    adjust: item.adjust
                }
            });

            let dataSave = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                items: items
            }

            await this.$store.dispatch("PAConservancyController/saveInterimReport", dataSave)
            .then(response => {
                this.$alertNotification("Successfully updated interim report", "success");
                this.activeSaveBtn = false
            })
            .catch(err => {
                if (err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "danger")
                }
            })
        }
    }
}
</script>